import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  padding: var(--space-100) var(--space-100) var(--space-100) var(--space-250);
  align-items: center;
  gap: var(--space-300);
  border-radius: var(--radius-brand);
  outline: 1px solid var(--border-primary);
  outline-offset: -1px;
`

export const MainContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  color: var(--text-secondary);
  font-family: var(--font-family-body);
  font-size: var(--font-size-200);
  font-style: normal;
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-200); /* 133.333% */
  letter-spacing: var(--font-letter-spacing-looser);
`

export const Actions = styled.div`
  display: flex;
  gap: var(--space-200);
  align-items: center;
`

export const Info = styled.div`
  display: flex;
  width: 164px;
`

export const Email = styled.div`
  text-decoration: none;
`
